<div class="loadback" [ngStyle]="{ 'display' : Visible == true ? 'block' : 'none'}">
  <div class="load-spinner">
    @if (Mode == 'spinner') {
      <app-loadingspinner></app-loadingspinner>
    }
    @if (Mode == 'cube') {
      <app-loadingcube></app-loadingcube>
    }
  </div>
</div>